import { Component, OnInit, HostListener, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LocalSystemService } from '../local-system.service';

@Component({
  selector: 'app-edit-delivery',
  templateUrl: './edit-delivery.component.html',
  styleUrls: ['./edit-delivery.component.scss']
})
export class EditDeliveryComponent implements OnInit {
  delivery_id:any;
  editDelivery:any;
  loaded:any = false;

  example:any = { selected:false, brand_example:"", model_internal_example:"", model_external_example:"" }
  modal:any = { open:false, obj:{ brand_selected:false, model_internal_selected:false, model_external_selected:false } };

  availableBrands:any = [];

  delivery_date_picker:any = false;
  current_delivery_date:any;
  current_delivery_month_dates:any = [];
  timeoutPicker:any;


  timeoutModelInternal:any;
  modelInternalSuggestion:any = [];

  timeoutModelExternal:any;
  modelExternalSuggestion:any;

  products:any = [];

  num:any = 0;

  holdStartIdx:any = 0;
  holdEndIdx:any = 0;
  holdField:any = "";
  holdStarted:any = false;

  tab:any = "products";
  audio:any;

  @HostListener('window:beforeunload')
  onBeforeUnload() {
      return confirm("Сигурни ли сте, че искате да излезете в процес на добавяне ?");
  }

  switchTab(tab) {  this.tab = tab; }

  public startHold(e, idx, type){
    if(!this.holdStarted) {
      this.holdEndIdx = 0;
      this.holdStartIdx = idx;
      this.holdStarted = true;
      this.holdField = type;
    }

  }

  public releaseHold(e, idx, type) {
    if(this.holdStarted) {
      this.holdStarted = false;
    }
  }

  clearFields(){
    let start_num = 0;
    let end_num = 0;
    if(this.holdStartIdx > this.holdEndIdx) { start_num = this.holdEndIdx; end_num = this.holdStartIdx; }
    else { start_num = this.holdStartIdx; end_num = this.holdEndIdx; }
    for(let i = start_num; i < end_num + 1; i++){
      this.products[i][this.holdField] = "";
    }
    this.holdStartIdx = 0;
    this.holdEndIdx = 0;
    this.holdField = '';
  }
  
  deleteRows() {
    let start_num = 0;
    let end_num = 0;
    if(this.holdStartIdx > this.holdEndIdx) { start_num = this.holdEndIdx; end_num = this.holdStartIdx; }
    else { start_num = this.holdStartIdx; end_num = this.holdEndIdx; }
    this.products.splice(start_num, (end_num - start_num) + 1);
    this.holdStartIdx = 0;
    this.holdEndIdx = 0;
    this.holdField = '';
    this.num = 0;
    for(let i = 0; i < this.products.length; i++){
      this.num += 1;
      this.products[i].num = this.num;
      if(this.products[i].splitter) { this.num = 0; }
    }
  }

  selectModel(idx, field, item) {
    if(field == 'model_internal') { item.selectingModelInternal = true; }
    if(field == 'model_external') { item.selectingModelExternal = true; }
    this.checkMarking(idx, field);
  }

  checkMarking(idx, field){
    if(this.holdStarted) {
      this.holdEndIdx = idx;
    } else {
      this.holdStartIdx = 0;
      this.holdEndIdx = 0;
      this.holdField = '';
      this.holdStarted = false;
    }
  }

  constructor(private activatedRoute:ActivatedRoute, private localSystem:LocalSystemService, private http:HttpClient, private router:Router, private ngZone:NgZone) {
    this.delivery_id = this.activatedRoute.snapshot.params.uid;
    this.getAvailableBrands();
    this.openModal('loading', {});
    this.http.get("api/service.php?action=get_deliveries&uid=" + this.delivery_id).subscribe((data) => {
      if(data['logged']) {
        this.editDelivery = data['deliveries'][0];
        this.editDelivery.delivered_at = new Date(this.editDelivery.delivered_at_reformed);
        this.current_delivery_date = new Date(this.editDelivery.delivered_at_reformed);
      } else {
        this.localSystem.Logout();
      }
    });
    this.http.get("api/service.php?action=get_delivery_products&delivery_id=" + this.delivery_id).subscribe((data) => {
      this.products = data['products'];
      for(let i = 0; i < this.products.length; i++) {
        this.num += 1;
        this.products[i].uuid = this.MakeUnique(16);
        this.products[i].num = this.num;
        this.products[i].original = true;
        this.products[i].removed = false;
        if(this.products[i].splitter) { this.num = 0; }
      }
      this.num += 1;
      this.products.push({ uuid:this.MakeUnique(16), num:this.num, selected:false, brand:this.example.brand_example, model_internal:this.example.model_internal_example, model_external:this.example.model_external_example, serial_internal:"", serial_external:"", original:false, removed:false });
      setTimeout(()=>{
        this.loaded = true;
        this.closeModal();
        this.ngZone.run(()=>{});
      }, 500);
    });
    this.audio = new Audio();
       // this.audio.src = "../../assets/audio/duplicate-alarm.wav";
       this.audio.src = "../../assets/audio/warranty.mp3";
    this.audio.load();
  }

  ngOnInit(): void {
  }

  reload() {
    this.router.navigateByUrl('/warranties', { skipLocationChange: true }).then(() => {
      this.router.navigate(["edit-delivery",this.delivery_id]);
    });
  }

  openPicker() {
    this.timeoutPicker = setTimeout(()=>{      
      this.delivery_date_picker = true; 
      this.current_delivery_date = new Date(this.editDelivery.delivered_at);
      this.Formulate(this.current_delivery_date);
    }, 50);
  }

  closePicker(ev) { 
    this.delivery_date_picker = false;
  }



  getAvailableBrands() {
    this.http.get("api/service.php?action=get_brands").subscribe((data) => {
      this.availableBrands = data['brands'];
    });
  }

  selectDate(dt){
    this.editDelivery.delivered_at.setYear(this.current_delivery_date.getFullYear());
    this.editDelivery.delivered_at.setDate(dt.date);
    this.editDelivery.delivered_at.setMonth(dt.month);
    this.delivery_date_picker = false;
  }

  nextMonth() { this.current_delivery_date.setMonth(this.current_delivery_date.getMonth() + 1); this.Formulate(this.current_delivery_date); }
  prevMonth() { this.current_delivery_date.setMonth(this.current_delivery_date.getMonth() - 1); this.Formulate(this.current_delivery_date); }

  selectInternalModel(idx, model) { this.products[idx].model_internal = model.name; }
  selectExternalModel(idx, model) { this.products[idx].model_external = model.name; }

  Formulate(dt) {
    this.current_delivery_month_dates = [];

    var firstDay = new Date(dt.getFullYear(), dt.getMonth(), 1);
    var lastDay = new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
    let predate_num = 0;
    // GENERATE PREDATE

    for(let i = 0; i < 42 - lastDay.getDate(); i++) {
        let day_idx = i;
        let first_day = firstDay.getDay();
        if(first_day == 0) { first_day = 7; }
        if(day_idx < first_day - 1) {
            let negative_day = day_idx * -1;
            let date_reformed = new Date(dt.getFullYear(), dt.getMonth(), negative_day);
            this.current_delivery_month_dates.unshift({ "date": date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false})
            predate_num += 1;
        }
    }
    for(let i = 0; i < lastDay.getDate(); i++) {
        let day_id = i + 1;
        this.current_delivery_month_dates.push({ "date":day_id, "month":dt.getMonth(), "active":true });
    }
    for(let i = 0; i < 42 - lastDay.getDate() - predate_num; i++) {
        let date_reformed = new Date(dt.getFullYear(), dt.getMonth() + 2, i + 1);
        this.current_delivery_month_dates.push({ "date":date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false });
    }
  }

  createSplitter() {
    this.products.push({ uuid:this.MakeUnique(16), splitter:true, 'brand':"", model_internal:"", model_external: "", serial_internal:"", serial_external:"", original:false, removed:false })
    this.num = 1;
    this.products.push({ uuid:this.MakeUnique(16), num:this.num, splitter:false, 'brand':"", model_internal:"", model_external: "", serial_internal:"", serial_external:"", original:false, removed:false })
  }

  checkForNewRow(uuid:number, type:String){
    let idx = this.products.findIndex( x => x.uuid == uuid );
    if(idx == this.products.length - 1) {
      if(this.products[idx].brand != "" || this.products[idx].model_internal != "" || this.products[idx].model_external != "" || this.products[idx].serial_internal != "" || this.products[idx].serial_external != ""){
        this.num += 1;
        this.products.push({ 'uuid':this.MakeUnique(16), 'num':this.num, splitter:false, selected:false, brand:this.example.brand_example, model_internal:this.example.model_internal_example, model_external:this.example.model_external_example, serial_internal:"", serial_external:"" });
      }
    }
    // if(idx == this.products.length - 1) {
    //   if(this.products[idx].brand != "" || this.products[idx].model_internal != "" || this.products[idx].model_external != "" || this.products[idx].serial_internal != "" || this.products[idx].serial_external != ""){
    //     this.num += 1;
    //     this.products.push({ uuid:this.MakeUnique(16), num:this.num, selected:false, brand:this.example.brand_example, model_internal:this.example.model_internal_example, model_external:this.example.model_external_example, serial_internal:"", serial_external:"" });
    //   }
    // }

    this.products[idx].model_internal = this.products[idx].model_internal.toUpperCase();
    this.products[idx].model_external = this.products[idx].model_external.toUpperCase();
    // this.products[idx].model_internal = this.returnTranslate(this.products[idx].model_internal);
    // this.products[idx].model_external = this.returnTranslate(this.products[idx].model_external);

    this.products[idx].serial_internal = this.products[idx].serial_internal.toUpperCase();
    this.products[idx].serial_external = this.products[idx].serial_external.toUpperCase();
    this.products[idx].serial_internal = this.returnTranslate(this.products[idx].serial_internal);
    this.products[idx].serial_external = this.returnTranslate(this.products[idx].serial_external);

    if(type == 'model_internal') { this.searchModelInternal(idx) }
    else if(type == 'model_external') { this.searchModelExternal(idx); }
  }

  searchModelInternal(idx) {
    if(this.products[idx].model_internal.length > 3) {
      clearTimeout(this.timeoutModelInternal);
      this.timeoutModelInternal = setTimeout(()=>{
        this.http.get("api/service.php?action=get_models&brand=" + this.products[idx].brand + "&model=" + this.products[idx].model_internal + "&type=1").subscribe((data) => {
          this.modelInternalSuggestion = data['models'];
        });
      }, 300);
    }
  }

  searchModelExternal(idx) {
    if(this.products[idx].model_external.length > 3) {
      clearTimeout(this.timeoutModelExternal);
      this.timeoutModelExternal = setTimeout(()=>{ 
        this.http.get("api/service.php?action=get_models&brand=" + this.products[idx].brand + "&model=" + this.products[idx].model_external + "&type=2").subscribe((data) => {
          this.modelExternalSuggestion = data['models'];
        });
      }, 300);
    }
  }

  saveExample() {
    let changed = false;
    if(this.modal.obj.brand_selected) { this.example.brand_example = this.editDelivery.items.filter(item => item.selected)[0].brand; changed = true; }
    if(this.modal.obj.model_internal_selected) { this.example.model_internal_example = this.editDelivery.items.filter(item => item.selected)[0].model_internal; changed = true; }
    if(this.modal.obj.model_external_selected) { this.example.model_external_example = this.editDelivery.items.filter(item => item.selected)[0].model_external; changed = true; }
    if(changed) { this.example.selected = true; }
    this.closeModal();
    for(let i = 0; i < this.editDelivery.items.length; i++) { this.editDelivery.items[i].selected = false; }
  }
  clearExample() { this.example = { selected:false, brand_example:"", model_internal_example:"", model_external_example:"" }; }

  openModal(cntx, obj) { this.modal = { open:true, 'cntx':cntx, 'obj':obj } }
  closeModal() { this.modal.open = false; }

  promptDuplicate() {
    var x = prompt("Въведете брой редове (1-400)", "0");
    var number = parseInt(x);
    if(number > 400) {
      alert("Въведете число между 1 и 400");
      this.promptDuplicate();
    } else {
      let example_product = this.products.filter(item => item.selected)[0];

      for(let i = 0; i < number; i++) {
        this.num += 1;
        this.products.push({ uuid:this.MakeUnique(16), num:this.num, 'brand':example_product.brand, model_internal:example_product.model_internal, model_external: example_product.model_external, serial_internal:"", serial_external:"" })
      }

      for(let i = 0 ; i < this.products.length; i++) { this.products[i].selected = false; }
    }
  }


  deselectItemInternal(idx) {
    setTimeout(()=>{ this.products[idx].selectingModelInternal = false }, 300);
  }

  deselectItemExternal(idx) {
    setTimeout(()=>{ this.products[idx].selectingModelExternal = false }, 300);
  }

  public onKey(event, field:String, idx:number) {
    setTimeout(()=>{
      let idx_found = this.products.findIndex(item => item.num == idx);
      if(field == 'serial_internal') {
        if(this.products.filter(item => item.serial_internal == this.products[idx_found].serial_internal).length > 1 && this.products[idx_found].serial_internal != ""){
          this.openModal('duplicate-serial', { 'serial':this.products[idx_found].serial_internal });
          this.audio.currentTime = 0;
          this.audio.play();
          this.products[idx_found].serial_internal = "";
          this.removeItem(idx_found, this.products[idx_found].uuid);
        } else {
          if(idx < this.products.length) {
            document.getElementById('serial_internal' + [idx + 1])?.focus();
          }
        }
      } else if(field == 'serial_external') {
        if(this.products.filter(item => item.serial_external == this.products[idx_found].serial_external).length > 1 && this.products[idx_found].serial_external != ""){
          this.openModal('duplicate-serial', { 'serial':this.products[idx_found].serial_external });
          this.audio.currentTime = 0;
          this.audio.play();
          this.products[idx_found].serial_external = "";
          this.removeItem(idx_found, this.products[idx_found].uuid);
        } else {
          if(idx < this.products.length) {
            document.getElementById('serial_external' + [idx + 1])?.focus();
          }
        }

      }
    }, 200);
    /* {event: KeyboardEvent, value: "sezmars", time: 0.07083499999716878, type: "scanner"} */
    /* {event: KeyboardEvent, value: "3333333", time: 0.17083499999716878, type: "keyboard"} */
  }

  EditDelivery(num) {
    this.openModal('editting-delivery', {});
    let postObject = { products:[], date: this.returnDateFormatedForStorage(this.editDelivery.delivered_at) };
    for(let i = 0; i < this.products.length; i++) {
      postObject.products.push(this.products[i]);
    }
    if(num == 1) {
      this.http.post("api/service.php?action=edit_delivery&name=" + this.editDelivery.name + "&comment=" + this.editDelivery.comment + "&document_number=" + this.editDelivery.document_number + "&container_id=" + this.editDelivery.container_id + "&delivery_id=" + this.delivery_id, postObject).subscribe((data) => {
        this.router.navigate(['deliveries']);
      });
    } else if(num == 2) {
      this.http.post("api/service.php?action=edit_delivery&name=" + this.editDelivery.name + "&comment=" + this.editDelivery.comment + "&document_number=" + this.editDelivery.document_number + "&container_id=" + this.editDelivery.container_id + "&delivery_id=" + this.delivery_id, postObject).subscribe((data) => {
        this.router.navigateByUrl('/warranties', { skipLocationChange: true }).then(() => {
          this.router.navigate(["edit-delivery",this.delivery_id]);
        });
      });
    }

  }

  removeItem(idx:number, uuid) { 
    if(this.products[idx].splitter) {
      if(this.products[idx].original) {
        this.products[idx].removed = true;
      } else {
        this.products.splice(idx, 1); 
      }
      this.num = 0;
      for(let i = 0; i < this.products.length; i++){
        if(!this.products[idx].removed) {
          this.num += 1;
          this.products[i].num = this.num;
          if(this.products[i].splitter) { this.num = 0; }
        }
      }
    } else {
      let num = 0;
      let start_idx = 0;
      for(let i = idx; i < this.products.length; i++){
        if(this.products[i].uuid == uuid) {
          num = this.products[i].num;
          if(this.products[idx].original) {
            this.products[i].removed = true;
          } else {
            this.products.splice(i, 1); 
          }
          start_idx = i;
        }
      }

      for(let i = idx; i < this.products.length; i++){
        if(this.products[i].num > num && i >= start_idx) { this.products[i].num -= 1; }
      }
      this.num = this.products[this.products.length - 1].num;
    }
  }

  MakeUnique(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() *  charactersLength));
    }
    return result;
  }

  returnAnySelected() {
    if(this.products.filter(item => item.selected).length > 0) { return true; }
    else { return false; }
  }

  returnDateFormatedForStorage(dt) {
    return dt.getFullYear() + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + this.returnPadZero(dt.getDate(), 2) +  " " +  this.returnPadZero(dt.getHours(), 2) + ":" + this.returnPadZero(dt.getMinutes(), 2) + ":" + this.returnPadZero(dt.getSeconds(), 2);
  }

  returnDateFormated(dt){
    return this.returnPadZero(dt.getDate(), 2) + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + dt.getFullYear();
  }

  returnYear(dt) { return dt.getFullYear(); }
  returnMonth(dt) { return dt.getMonth() + 1; }
  returnMonthName(month) {
    if(month == 1) { return "Януари"; }
    else if(month == 2) { return "Февруари"; }
    else if(month == 3) { return "Март"; }
    else if(month == 4) { return "Април"; }
    else if(month == 5) { return "Май"; }
    else if(month == 6) { return "Юни"; }
    else if(month == 7) { return "Юли"; }
    else if(month == 8) { return "Август"; }
    else if(month == 9) { return "Септември"; }
    else if(month == 10) { return "Октомври"; }
    else if(month == 11) { return "Ноември"; }
    else if(month == 12) { return "Декември"; }
    else { return ""; }
  }
  returnDate(dt) { return dt.getDate();  }
  returnPadZero(number, length) {
    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }


  // returnTranslate = function(text) {
  //   text = text
  //       .replace(/\u0401/g, 'YO')
  //       .replace(/\u0419/g, 'I')
  //       .replace(/\u0426/g, 'TS')
  //       .replace(/\u0423/g, 'U')
  //       .replace(/\u041A/g, 'K')
  //       .replace(/\u0415/g, 'E')
  //       .replace(/\u041D/g, 'N')
  //       .replace(/\u0413/g, 'G')
  //       .replace(/\u0428/g, 'SH')
  //       .replace(/\u0429/g, 'SCH')
  //       .replace(/\u0417/g, 'Z')
  //       .replace(/\u0425/g, 'H')
  //       .replace(/\u042A/g, '')
  //       .replace(/\u0451/g, 'yo')
  //       .replace(/\u0439/g, 'i')
  //       .replace(/\u0446/g, 'ts')
  //       .replace(/\u0443/g, 'u')
  //       .replace(/\u043A/g, 'k')
  //       .replace(/\u0435/g, 'e')
  //       .replace(/\u043D/g, 'n')
  //       .replace(/\u0433/g, 'g')
  //       .replace(/\u0448/g, 'sh')
  //       .replace(/\u0449/g, 'sch')
  //       .replace(/\u0437/g, 'z')
  //       .replace(/\u0445/g, 'h')
  //       .replace(/\u044A/g, "'")
  //       .replace(/\u0424/g, 'F')
  //       .replace(/\u042B/g, 'I')
  //       .replace(/\u0412/g, 'V')
  //       .replace(/\u0410/g, 'a')
  //       .replace(/\u041F/g, 'P')
  //       .replace(/\u0420/g, 'R')
  //       .replace(/\u041E/g, 'O')
  //       .replace(/\u041B/g, 'L')
  //       .replace(/\u0414/g, 'D')
  //       .replace(/\u0416/g, 'ZH')
  //       .replace(/\u042D/g, 'E')
  //       .replace(/\u0444/g, 'f')
  //       .replace(/\u044B/g, 'i')
  //       .replace(/\u0432/g, 'v')
  //       .replace(/\u0430/g, 'a')
  //       .replace(/\u043F/g, 'p')
  //       .replace(/\u0440/g, 'r')
  //       .replace(/\u043E/g, 'o')
  //       .replace(/\u043B/g, 'l')
  //       .replace(/\u0434/g, 'd')
  //       .replace(/\u0436/g, 'zh')
  //       .replace(/\u044D/g, 'e')
  //       .replace(/\u042F/g, 'Ya')
  //       .replace(/\u0427/g, 'CH')
  //       .replace(/\u0421/g, 'S')
  //       .replace(/\u041C/g, 'M')
  //       .replace(/\u0418/g, 'I')
  //       .replace(/\u0422/g, 'T')
  //       .replace(/\u042C/g, "'")
  //       .replace(/\u0411/g, 'B')
  //       .replace(/\u042E/g, 'YU')
  //       .replace(/\u044F/g, 'ya')
  //       .replace(/\u0447/g, 'ch')
  //       .replace(/\u0441/g, 's')
  //       .replace(/\u043C/g, 'm')
  //       .replace(/\u0438/g, 'i')
  //       .replace(/\u0442/g, 't')
  //       .replace(/\u044C/g, "'")
  //       .replace(/\u0431/g, 'b')
  //       .replace(/\u044E/g, 'yu');

  //   return text;
  // };

  returnTranslate = function(text) {
    text = text
        .replace(/\u0401/g, '')
        .replace(/\u0419/g, '')
        .replace(/\u0426/g, '')
        .replace(/\u0423/g, '')
        .replace(/\u041A/g, '')
        .replace(/\u0415/g, '')
        .replace(/\u041D/g, '')
        .replace(/\u0413/g, '')
        .replace(/\u0428/g, '')
        .replace(/\u0429/g, '')
        .replace(/\u0417/g, '')
        .replace(/\u0425/g, '')
        .replace(/\u042A/g, '')
        .replace(/\u0451/g, '')
        .replace(/\u0439/g, '')
        .replace(/\u0446/g, '')
        .replace(/\u0443/g, '')
        .replace(/\u043A/g, '')
        .replace(/\u0435/g, '')
        .replace(/\u043D/g, '')
        .replace(/\u0433/g, '')
        .replace(/\u0448/g, '')
        .replace(/\u0449/g, '')
        .replace(/\u0437/g, '')
        .replace(/\u0445/g, '')
        .replace(/\u044A/g, "")
        .replace(/\u0424/g, '')
        .replace(/\u042B/g, '')
        .replace(/\u0412/g, '')
        .replace(/\u0410/g, '')
        .replace(/\u041F/g, '')
        .replace(/\u0420/g, '')
        .replace(/\u041E/g, '')
        .replace(/\u041B/g, '')
        .replace(/\u0414/g, '')
        .replace(/\u0416/g, '')
        .replace(/\u042D/g, '')
        .replace(/\u0444/g, '')
        .replace(/\u044B/g, '')
        .replace(/\u0432/g, '')
        .replace(/\u0430/g, '')
        .replace(/\u043F/g, '')
        .replace(/\u0440/g, '')
        .replace(/\u043E/g, '')
        .replace(/\u043B/g, '')
        .replace(/\u0434/g, '')
        .replace(/\u0436/g, '')
        .replace(/\u044D/g, '')
        .replace(/\u042F/g, '')
        .replace(/\u0427/g, '')
        .replace(/\u0421/g, '')
        .replace(/\u041C/g, '')
        .replace(/\u0418/g, '')
        .replace(/\u0422/g, '')
        .replace(/\u042C/g, "")
        .replace(/\u0411/g, '')
        .replace(/\u042E/g, '')
        .replace(/\u044F/g, '')
        .replace(/\u0447/g, '')
        .replace(/\u0441/g, '')
        .replace(/\u043C/g, '')
        .replace(/\u0438/g, '')
        .replace(/\u0442/g, '')
        .replace(/\u044C/g, "")
        .replace(/\u0431/g, '')
        .replace(/\u044E/g, '');

    return text;
  };

  returnTotalProducts() {
    let count = 0;
    count += this.products.filter(item => item.brand != '' || item.model_internal != '' || item.serial_internal != '').length;
    count += this.products.filter(item => item.serial_external != ''  || item.model_external != '').length;
    return count;
  }

  trackByFn(index, item) {
    return item.uuid;}
}
